import { render } from "./WelcomeView.vue?vue&type=template&id=8efc8a04&scoped=true&ts=true"
import script from "./WelcomeView.vue?vue&type=script&lang=ts"
export * from "./WelcomeView.vue?vue&type=script&lang=ts"

import "./WelcomeView.vue?vue&type=style&index=0&id=8efc8a04&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8efc8a04"]])

export default __exports__